import { IconPlus } from '@tabler/icons-react';
import React from 'react';
import {
  BasicActionIcon,
  IBasicActionIconProps,
} from 'src/design/atoms/BasicActionIcon';

export type ICreateActionIconProps = Omit<IBasicActionIconProps, 'children'>;

const DefaultProps: Partial<ICreateActionIconProps> = {
  color: 'blue',
};

/** @registry Blue "create" action icon (plus symbol) built on BasicActionIcon. */
export const CreateActionIcon = React.forwardRef<
  HTMLButtonElement,
  ICreateActionIconProps
>((props, ref) => {
  return (
    <BasicActionIcon {...DefaultProps} {...props} ref={ref}>
      <IconPlus size={20} />
    </BasicActionIcon>
  );
});
CreateActionIcon.displayName = 'CreateActionIcon';
